import config from 'constants/config'

export function downloadPdf(
  blob: Blob,
  fileName: string,
) {
  if (typeof window.appInterface?.downloadDataReceived === 'function') {
    // get blob as base64 string and send to native
    const reader = new FileReader()
    reader.onloadend = () => {
      const base64String = reader.result as string
      window.appInterface.downloadDataReceived(fileName, blob.type, base64String)
    }
    reader.readAsDataURL(blob)
  } else {
    // download by adding an anchor with download and clicking it
    const pdfURL = URL.createObjectURL(blob)
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.style.display = 'none'
    a.href = pdfURL
    a.download = fileName
    a.click()
    URL.revokeObjectURL(pdfURL)
  }
}

/**
 * Redirect to Google Docs to render PDF.
 * NOTE: This is a fallback for Android app as it does not support downloading PDF files.
 *
 * @param pdfAPIPath API path to the PDF file
 */
export function redirectToPdf(pdfAPIPath: string) {
  const domain = config.API_HOST
  const pdfUrl = `https://docs.google.com/gview?embedded=true&url=https://${domain}${pdfAPIPath}`
  window.location.href = pdfUrl
}
